import { NewsSourceOverrides } from "@bluframe/mightychroma-mightytool-frontend-types"
import { ChangeEventHandler } from "react"

import Overrides from "./Overrides"

export interface Props {
  onNameChange: ChangeEventHandler<HTMLInputElement>
  onTextChange: ChangeEventHandler<HTMLTextAreaElement>
  overrides: NewsSourceOverrides
}

export interface ComponentProps extends Props {}

export default Overrides
